import React from "react"

import {FieldGlistGroupProps} from "../../../../../render/glist/glist-group"
import ProjectIconUI5 from "../../../../../../gd-components/icons/project/project-icon-ui5"
import {ItemIconSize} from "../../../../../../gd-components/icons/@const";

export default function FieldProject_GlistGroupStandard(props:FieldGlistGroupProps) {

    const project               = gd.session.projects.get(props.data.value)!
    const colorClass: string    = 'gd-c-{0}'.f(project.color)
    const classes: string       = Classes("group-cards colored-background", colorClass)

    return (
        <div className={classes}>
            <ProjectIconUI5 className="icon m-r-10" size={ItemIconSize.SIZE_13} projectId={props.data.value} colorize={false}/>
            <div className="text">{project.name}</div>
            {!!props.data.isCollapsed && <div className="counter">{props.data.counter}</div>}

            {!props.data.isCollapsed &&
                <div className="group-corners">
                    <div className={Classes("top-corner", colorClass)}/>
                </div>}
        </div>
    )
}
